import {ApiClientFactory} from '../ApiClientFactory';

let clientFactory = new ApiClientFactory();

export const AuthClient = {

	/**
	 * Sends a login request.
	 *
	 * @param {Object} data
	 * @param {Object} headers
	 */
	login(data, headers = {}) {
		return clientFactory.post('auth/login', data, headers);
	},

	/**
	 * Sends a register request.
	 *
	 * @param {Object} data
	 * @param {Object} headers
	 */
	register(data, headers = {}) {
		return clientFactory.post('auth/register', data, headers);
	},

	/**
	 * Sends a forgot password request to the backend which sends a link
	 * to the user via email which contains the reset password link.
	 *
	 * @param {Object} data
	 * @param {Object} headers
	 */
	sendForgotPassword(data, headers = {}) {
		return clientFactory.post('auth/forgot-password', data, headers);
	},

	/**
	 * Sends a reset password request which resets the user's password.
	 *
	 * @param {Object} data
	 * @param {Object} headers
	 */
	resetPassword(data, headers = {}) {
		return clientFactory.post('auth/reset-password', data, headers);
	}
};